import Loader from "@/components/loader/Loader.vue";
import moment from "moment";
import firebase from "firebase/app";
import {serializer} from "@/api/shared/serializer";
import {GalleryStockPhotosMixin} from "@/mixins/GalleryStockPhotos";

export default {
  name: "GalleryStockPhotos",
  components: {
    Loader
  },
  mixins: [GalleryStockPhotosMixin],
  data() {
    return {
      loading: true,
      favourites: [],
      startDate: moment().subtract(1, 'month').toISOString().substring(0, 10),
      endDate: moment().toISOString().substring(0, 10),
      picker: {
        start: false,
        end: false,
      },
    }
  },
  computed: {
    formattedStartDate() {
      return moment(this.startDate).format(this.facility.dateFormat);
    },
    formattedEndDate() {
      return moment(this.endDate).format(this.facility.dateFormat);
    },
  },
  async created() {
    Promise.all([
      this.getFavouritePhotos()
    ]).then(() => {
      this.loading = false;
    })
  },
  methods: {
    async getFavouritePhotos() {
      const startDate = moment(this.startDate).startOf('day').unix() * 1000;
      const endDate = moment(this.endDate).endOf('day').unix() * 1000;

      await firebase
        .firestore()
        .collection("photos")
        .where("facilityId", "==", this.facility.id)
        .where("isStock", "==", true)
        .where('createdAt', '>=',  startDate)
        .where('createdAt','<=',  endDate)
        .orderBy("createdAt", "desc")
        .get()
        .then((data) => {
          this.favourites = serializer.querySnapshotToDocuments(data).sort((a: any, b: any) => moment(b.createdAt).diff(moment(a.createdAt)));
        })
    },
    async deletePhoto() {
      this.loading = true;

      try {
        for(let i = 0; i < this.selectedFavouritesPhotos.length; i++) {
          const photo = this.selectedFavouritesPhotos[i];

          await firebase
            .firestore()
            .collection("photos")
            .doc(photo.id)
            .delete()
        }

        await this.getFavouritePhotos();

        this.$toast.open({
          message: this.$t("Gallery.PhotosSuccessfullyDeleted"),
          type: "success",
        });

        this.loading = false;
        this.selectedFavouritesPhotos = [];
      } catch (error) {
        this.$toast.open({
          message: error.message,
          type: "error",
        });
      }
    }
  }
}